import { render } from "./Loading.vue?vue&type=template&id=41a752c7&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=41a752c7&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\code\\Dataleading3.0\\dataleading\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a752c7"]])

export default __exports__